import { Stack } from "@mantine/core";
import { IconBulb, IconClipboardData, IconId, IconKey, IconPalette } from "@tabler/icons-react";
import { NavLink } from "react-router-dom";
import useGetColaboradorById from "@/modules/colaboradores/hooks/useGetColaboradorById";
import useUserStore from "@/modules/users/store";
import { getCurrentUser } from "@/services/auth";
import {
  ID_CONFIGURACAO_CONTAS_EMAIL,
  ID_CONFIGURACAO_EVENTOS_EMAIL,
  ID_CONFIGURACAO_FORMULARIO_IDEIAS,
  ID_CONFIGURACAO_TEMPLATES_RELATORIOS,
  ID_CONFIGURACOES_PERSONALIZACAO
} from "@/utils/constants";
import NavLinkMenu from "./NavLinkMenu";
import Can from "../can";
// prettier-ignore
const AppConfigurationMenu = ({ toggleMobile }: { toggleMobile: () => void }) => {
  const activeEmpresa = useUserStore((store) => store.activeEmpresa);
  const activeAutorizacao = useUserStore((store) => store.autorizacoes);
  const uid = getCurrentUser()?.uid;
  const { data: userColaborador } = useGetColaboradorById(activeEmpresa?.id || "", uid || "");
  if (activeEmpresa && activeEmpresa?.status === "INATIVO") {
    return <></>;
  }
  const autorizacao = data.find(item => item.label === userColaborador?.role);
  const formatAutorizacoes = activeAutorizacao?.filter(item => item.tipo === autorizacao?.value);
  const isEmpresaConvidada = activeEmpresa?.role === 'CONVIDADA';

  return (
    <Stack mx="md" mt="lg" gap="xs">
      <NavLinkMenu label="Cadastros" leftSection={<IconId size="1.2rem" stroke={1.5} />}>
        <Can I="read" a="TEmpresa">
          {isEmpresaConvidada ? (
            formatAutorizacoes?.find(item => item.tipoAutorizacao === "1")?.leitura ?
              <NavLinkMenu label="Empresas Convidadas" component={NavLink} onClick={toggleMobile} to="/empresas-convidadas" /> : <></>
          ) : (
            <>
              {formatAutorizacoes?.find(item => item.tipoAutorizacao === "1")?.leitura ? <NavLinkMenu label="Empresas" component={NavLink} onClick={toggleMobile} to="/empresas" /> : <></>}
              {formatAutorizacoes?.find(item => item.tipoAutorizacao === "1")?.leitura ? <NavLinkMenu label="Empresas Convidadas" component={NavLink} onClick={toggleMobile} to="/empresas-convidadas" /> : <></>}
            </>
          )}
        </Can>
        <Can I="read" a="TColaborador">
          {formatAutorizacoes?.find(item => item.tipoAutorizacao === "2")?.leitura ? <NavLinkMenu label="Colaboradores" component={NavLink} onClick={toggleMobile} to="/colaboradores" /> : <></>}
        </Can>
        {formatAutorizacoes?.find((item) => item.tipoAutorizacao === ID_CONFIGURACAO_CONTAS_EMAIL)?.leitura && (
          <NavLinkMenu
            label="Contas de Email"
            component={NavLink}
            onClick={toggleMobile}
            to="/configuracoes/email-accounts"
          />
        )}
        {formatAutorizacoes?.find((item) => item.tipoAutorizacao === ID_CONFIGURACAO_EVENTOS_EMAIL)?.leitura && (
          <NavLinkMenu
            label="Eventos de Email"
            component={NavLink}
            onClick={toggleMobile}
            to="/configuracoes/email-events"
          />
        )}

      </NavLinkMenu>

      {userColaborador?.role === "ADMIN" ? <NavLinkMenu
        label="Autorizações"
        leftSection={<IconKey size="1.2rem" stroke={1.5} />}
        component={NavLink}
        onClick={toggleMobile}
        to="/autorizacoes"
      /> : <></>}

      {formatAutorizacoes?.find((item) => item.tipoAutorizacao === ID_CONFIGURACOES_PERSONALIZACAO)?.leitura && (
        <NavLinkMenu
          label="Personalização"
          leftSection={<IconPalette size="1.2rem" stroke={1.5} />}
          component={NavLink}
          onClick={toggleMobile}
          to="/configuracoes/personalizacao"
        />
      )}

      <NavLinkMenu label="Gestão de Inovação" leftSection={<IconBulb size="1.2rem" stroke={1.5} />}>
        {formatAutorizacoes?.find(item => item.tipoAutorizacao === ID_CONFIGURACAO_FORMULARIO_IDEIAS)?.leitura ? <NavLinkMenu label="Configuração de Ideias" component={NavLink} onClick={toggleMobile} to="/configuracoes/gestao-de-inovacao/configuracao-ideias" /> : <></>}
      </NavLinkMenu>

      <NavLinkMenu label="Diagnóstico" leftSection={<IconClipboardData size="1.2rem" stroke={1.5} />}>
        {formatAutorizacoes?.find(item => item.tipoAutorizacao === ID_CONFIGURACAO_TEMPLATES_RELATORIOS)?.leitura ? <NavLinkMenu label="Templates Relatórios" component={NavLink} onClick={toggleMobile} to="/configuracoes/diagnostico/templates" /> : <></>}
      </NavLinkMenu>

    </Stack>
  );
};

export default AppConfigurationMenu;

const data = [
  { value: "1", label: "ADMIN" },
  { value: "2", label: "MEMBER" },
  { value: "3", label: "TEAM" },
  { value: "4", label: "MASTER" },
  { value: "5", label: "COLLABORATOR" }
];
